<p>modify-vendor works!</p>
